import type { Lang } from "@/lib/content";
type Bi = Record<Lang, string>;
export const locationContext: Record<
  string,
  { title: Bi; body: Bi; checklist: Bi[]; source: string; sourceLabel: Bi }
> = {
  baghdad: {
    title: { en: "Preparing for a Baghdad tender", ar: "التحضير لمناقصة في بغداد" },
    body: {
      en: "Start with the actual tender documents. Iraq’s Ministry of Planning publishes government contracting guidance and standard documents; the buyer’s current conditions determine the evidence your bid needs.",
      ar: "ابدأ بوثائق المناقصة الفعلية. تنشر وزارة التخطيط العراقية إرشادات التعاقد الحكومي والوثائق القياسية؛ وتحدد شروط المشتري الحالية الأدلة المطلوبة لعرضك.",
    },
    checklist: [
      {
        en: "Share the tender’s ISO and accreditation clause, including the required submission date.",
        ar: "أرسل بند الأيزو والاعتماد في المناقصة، مع موعد التقديم المطلوب.",
      },
      {
        en: "Match the proposed certificate scope to the activities and sites named in the bid.",
        ar: "طابق نطاق الشهادة المقترح مع الأنشطة والمواقع المذكورة في العرض.",
      },
      {
        en: "Confirm the buyer’s acceptance of the proposed certification body before booking an audit.",
        ar: "تأكد من قبول المشتري لجهة منح الشهادات المقترحة قبل حجز التدقيق.",
      },
    ],
    source: "https://mop.gov.iq/en/general-government-contracts-department",
    sourceLabel: {
      en: "Ministry of Planning: government contracts",
      ar: "وزارة التخطيط: العقود الحكومية",
    },
  },
  basra: {
    title: {
      en: "ISO preparation and operator registration",
      ar: "التحضير للأيزو والتسجيل لدى المشغلين",
    },
    body: {
      en: "For a Basra oil-and-gas supplier, certification and operator registration are separate workstreams. Basra Oil Company publishes its own tender notices. Use the intended operator’s current documents rather than assuming that one certificate or registration covers every buyer.",
      ar: "للمورد في قطاع النفط والغاز في البصرة، الشهادة والتسجيل لدى المشغل مساران منفصلان. تنشر شركة نفط البصرة إعلانات مناقصاتها. استخدم وثائق المشغل المستهدف الحالية بدلاً من افتراض أن شهادة أو تسجيلاً واحداً يغطي جميع المشترين.",
    },
    checklist: [
      {
        en: "Identify the operator, supplier category and exact registration or tender requirement.",
        ar: "حدد المشغل وفئة المورد ومتطلب التسجيل أو المناقصة بدقة.",
      },
      {
        en: "Check legal-entity details, supporting records and management-system scope together.",
        ar: "راجع بيانات الكيان القانوني والسجلات الداعمة ونطاق نظام الإدارة معاً.",
      },
      {
        en: "Treat ISO 29001 accreditation as a separate scope check; it is outside AQSR’s disclosed UAF scope.",
        ar: "تحقق من اعتماد ISO 29001 بصورة منفصلة؛ فهو خارج نطاق اعتماد UAF المعلن لشركة AQSR.",
      },
    ],
    source: "https://boc.oil.gov.iq/",
    sourceLabel: {
      en: "Basra Oil Company: official website",
      ar: "شركة نفط البصرة: الموقع الرسمي",
    },
  },
  erbil: {
    title: {
      en: "Aligning company records in the Kurdistan Region",
      ar: "مواءمة سجلات الشركة في إقليم كردستان",
    },
    body: {
      en: "The KRG Business Registration System provides company registration and business-information services. Those legal records serve a different purpose from ISO certification. Align the registered company name, activities and sites with the management system you plan to certify.",
      ar: "يقدم نظام تسجيل الأعمال لحكومة إقليم كردستان خدمات تسجيل الشركات وبيانات الأعمال. لهذه السجلات القانونية غرض مختلف عن شهادة الأيزو. طابق اسم الشركة المسجل والأنشطة والمواقع مع نظام الإدارة المراد منحه الشهادة.",
    },
    checklist: [
      {
        en: "Bring the current company registration and the buyer’s written requirement.",
        ar: "جهّز تسجيل الشركة الحالي ومتطلب المشتري المكتوب.",
      },
      {
        en: "Clarify which locations, services and teams belong in the certification scope.",
        ar: "حدد المواقع والخدمات والفرق التي يشملها نطاق الشهادة.",
      },
      {
        en: "Confirm buyer acceptance and agree remote support or a client-site visit with our Erbil-based team.",
        ar: "تأكد من قبول المشتري واتفق على دعم عن بُعد أو زيارة لموقع العميل مع فريقنا في أربيل.",
      },
    ],
    source: "https://business.digital.gov.krd/en",
    sourceLabel: {
      en: "KRG: Business Registration System",
      ar: "حكومة الإقليم: نظام تسجيل الأعمال",
    },
  },
};
